import { Utils } from '../Utils';
var BSHelpers = /** @class */ (function () {
    function BSHelpers() {
    }
    BSHelpers.getInverseBreakpointClasses = function (props) {
        function getInverse(cols) {
            return cols === 12 ? 12 : 12 - cols;
        }
        var cols = Utils.joinWithSpaces(props.xs && "col-" + props.xs, props.sm && "col-sm-" + props.sm, props.md && "col-md-" + props.md, props.lg && "col-lg-" + props.lg, props.xl && "col-xl-" + props.xl, props.xxl && "col-xxl-" + props.xxl);
        var inverseCols = Utils.joinWithSpaces(props.xs && "col-" + getInverse(props.xs), props.sm && "col-sm-" + getInverse(props.sm), props.md && "col-md-" + getInverse(props.md), props.lg && "col-lg-" + getInverse(props.lg), props.xl && "col-xl-" + getInverse(props.xl), props.xxl && "col-xxl-" + getInverse(props.xxl));
        return { cols: cols, inverseCols: inverseCols };
    };
    BSHelpers.getFirstBreakpoint = function (props) {
        if (props.xs && props.xs != 12)
            return "xs";
        if (props.sm && props.sm != 12)
            return "sm";
        if (props.md && props.md != 12)
            return "md";
        if (props.lg && props.lg != 12)
            return "lg";
        if (props.xl && props.xl != 12)
            return "xl";
        if (props.xxl && props.xxl != 12)
            return "xxl";
        return null;
    };
    return BSHelpers;
}());
export default BSHelpers;
